import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type CheckIn} from 'web-app/react/entities/common/checkin';

import type * as Models from './models';

const domain = 'CHILD_SIGNIN';

interface SignInPayload {
    childId: string;
    pickupTime?: string;
    relationId?: string;
    statementIds?: string[];
}

interface EmployeeSignInPayload {
    employeeId: string;
    group: Models.EmployeeGroup;
    statementIds?: string[];
    name: string;
}

interface EmployeeSignoutPayload {
    employeeId: string;
    name: string;
}

export const {action: show} = createAction(`${domain}/SHOW`, (isQRSignInEnabled?: boolean) => ({isQRSignInEnabled}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: selectPickupPerson} = createAction(
    `${domain}/SELECT_PICKUP_PERSON`,
    ({pickupRelationId, childId}: {pickupRelationId: string; childId: string}) => ({pickupRelationId, childId}),
);

export const {
    action: updateSignIn,
    success: updateSignInSuccess,
    failed: updateSignInFailed,
} = createAction(
    `${domain}/UPDATE_SIGNIN`,
    (signIn: SignInPayload) => ({signIn}),
    (response: CheckIn) => ({response}),
    (e: Error, childId: string) => ({childId}),
);

export const {
    action: signInEmployee,
    success: signInEmployeeSuccess,
    failed: signInEmployeeFailed,
} = createAction(
    `${domain}/SIGNIN_EMPLOYEE`,
    (payload: EmployeeSignInPayload) => payload,
    (employeeId: string, group: Models.EmployeeGroup, response) => ({employeeId, group, response}),
    (employeeId: string) => ({employeeId}),
);

export const {
    action: signOutEmployee,
    success: signOutEmployeeSuccess,
    failed: signOutEmployeeFailed,
} = createAction(
    `${domain}/SIGNOUT_EMPLOYEE`,
    (payload: EmployeeSignoutPayload) => payload,
    (employeeId: string, response) => ({employeeId, response}),
    (employeeId: string) => ({employeeId}),
);

export const {
    action: fetchPossibilitiesFromLocation,
    success: fetchPossibilitiesFromLocationSuccess,
    failed: fetchPossibilitiesFromLocationFailed,
} = createAction(
    `${domain}/FETCH_POSSIBILITIES_FROM_LOCATIONS`,
    () => null,
    (response: Models.CheckinFromLocation) => ({response}),
);

export const {action: setPossibilitiesFromQRCode} = createAction(
    `${domain}/FETCH_POSSIBILITIES_FROM_QR_CODE`,
    (payload: Models.CheckinFromQRCode) => payload,
);

export const {
    action: signOut,
    success: signOutSuccess,
    failed: signOutFailed,
} = createAction(
    `${domain}/SIGNOUT`,
    (childId: string) => ({childId}),
    (response: CheckIn) => ({response}),
    (e: Error, childId: string) => ({childId}),
);

export const {action: setQRScannerCameraOpen} = createAction(`${domain}/SET_CAMERA_OPEN`, () => ({}));
export const {action: setQRScannerCameraClosed} = createAction(`${domain}/SET_CAMERA_CLOSED`, () => ({}));
